import Address from '../libs/location.json'
// 获取
const getCNLocation = () => {
  const allAry = []
  Object.keys(Address).forEach((key) => {
    const adDist = Address[key]
    const provinceDist = {}
    provinceDist.value = key
    provinceDist.name = adDist.name

    const cityAry = []
    const provinceChild = adDist.child
    Object.keys(provinceChild).forEach((key) => {
      const pcDist = provinceChild[key]
      const cityDist = {}
      cityDist.value = key
      cityDist.name = pcDist.name

      const areaAry = []
      const cityChild = pcDist.child
      Object.keys(cityChild).forEach((key) => {
        const areaDist = {}
        areaDist.value = key
        areaDist.name = cityChild[key]
        areaAry.push(areaDist)
      })
      cityDist.children = areaAry
      cityAry.push(cityDist)
    })
    provinceDist.children = cityAry
    allAry.push(provinceDist)
  })
  // console.log(allAry)
  return allAry
}

export { getCNLocation }



// WEBPACK FOOTER //
// ./src/util/location.js